export default __webpack_public_path__ + "static/media/Newsletter 020.1be69269.png";